<template>
  <div class="mine">
    <bread :list="list"></bread>
    <i class="line"></i>
    <div>
      <div class="margin-top-40 text-24 text-cut-one">{{info.news_title}}</div>
      <div class="margin-tb-20 text-12 text-99">{{info.news_time}}</div>
      <div
        class="word-word padding-bottom-40 margin-top-40 padding-lr-60 line-18"
        v-html="info.news_content"
      >{{info.news_content}}</div>
    </div>
  </div>
</template>

<script>
import bread from "../../components/bread";
export default {
    components: {
        bread
    },
    data() {
        return {
             list: [
                {
                title: "用户信息"
                },
                {
                title: "公告详情"
                }
            ],
        info: ""
    };
  },
  created() {
    this.getNew();
  },
  methods: {
    getNew() {
      this.post(this, "/home/news/info", {
        token: window.localStorage.getItem("pc_token"),
        news_id: this.$route.query.id
      }).then(res => {
        this.info = res.data.data;
      });
    }
  }
};
</script>


<style scoped>
.word-word {
  word-break: break-word;
}
.line-180p{
  line-height: 1.8;
}
</style>